export enum IconsName {
  ACTIVATE = 'activate',
  ADD_USER = 'add-user',
  ANCHOR = 'anchor',
  ARROW_DOWN = 'arrow-down',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  ARROW_SORT_DOWN = 'arrow-sort-down',
  ARROW_SORT_UP = 'arrow-sort-up',
  ARROW_UP = 'arrow-up',
  ARTICLE = 'article',
  ASSURANCE = 'assurance',
  AVAILABILITY = 'availability',
  BILLING = 'billing',
  BOOKMARK = 'bookmark',
  BULLET = 'bullet',
  CALENDAR = 'calendar',
  CALLBACK = 'callback',
  CAMERA = 'camera',
  CART_ADD = 'cart-add',
  CART_EMPTY = 'cart-empty',
  CART_FULL = 'cart-full',
  CATEGORIES = 'categories',
  CHECKBOX_PLUS_CHECKED = 'checkbox-plus-checked',
  CHECKBOX_PLUS = 'checkbox-plus',
  CLEAR = 'clear',
  CONTACT = 'contact',
  CREATE = 'create',
  CROSS = 'cross',
  CURRENCY = 'currency',
  DANGER_SOLID = 'danger-solid',
  DEACTIVATE_USER = 'deactivate-user',
  DICTATE = 'dictate',
  DIRECTION = 'direction',
  DISCUSSION = 'discussion',
  DOCUMENT = 'document',
  DOWNLOAD = 'download',
  EDIT = 'edit',
  EDUCATION = 'education',
  FACEBOOK = 'facebook',
  FAVORITE_HEART = 'favorite-heart',
  FAVORITE_STAR = 'favorite-star',
  FILTER = 'filter',
  FLAG = 'flag',
  GPS = 'gps',
  GRAPH = 'graph',
  HAMBURGER = 'hamburger',
  HIDE_PASS = 'hide-pass',
  INFO_SOLID = 'info-solid',
  INFO = 'info',
  INFOSOLO = 'infosolo',
  INSTAGRAM = 'instagram',
  KAKAO = 'kakao',
  LAPTOP = 'laptop',
  LINKEDIN = 'linkedin',
  LIST = 'list',
  LOCATION = 'location',
  LOCK = 'lock',
  LOD = 'lod',
  LOGOUT = 'logout',
  MAIL = 'mail',
  MAP = 'map',
  MIF = 'mif',
  MOVE_TO = 'move-to',
  OVERFLOW_HORIZ = 'overflow-horiz',
  OVERFLOW_VERT = 'overflow-vert',
  PDF = 'pdf',
  PHONE = 'phone',
  PINTEREST = 'pinterest',
  PLAY = 'play',
  PLUS = 'plus',
  PRINT = 'print',
  PRODUCTS = 'products',
  PROFILE = 'profile',
  QUESTION = 'question',
  RADIO_PLUS_CHECKED = 'radio-plus-checked',
  RADIO_PLUS = 'radio-plus',
  RE_ORDER = 're-order',
  RE_SORT = 're-sort',
  REMOVE = 'remove',
  REPLY = 'reply',
  RESET = 'reset',
  SCAN = 'scan',
  SEARCH = 'search',
  SELECT_ALL_CHECKED = 'select-all-checked',
  SELECT_ALL = 'select-all',
  SHARE = 'share',
  SHIPMENT = 'shipment',
  SHOW_PASS = 'show-pass',
  SORT_DOWN = 'sort-down',
  SORT_UNSORTED = 'sort-unsorted',
  SORT_UP = 'sort-up',
  SPANNER_ANGLED = 'spanner-angled',
  SPANNER = 'spanner',
  START_OVER = 'start-over',
  SUBSCRIPTION = 'subscription',
  SUCCESS_SOLID = 'success-solid',
  TAG = 'tag',
  THUMBS_UP = 'thumbs-up',
  TICK = 'tick',
  TIME = 'time',
  TRANSFER = 'transfer',
  TRASH = 'trash',
  TWITTER = 'twitter',
  UNSORTED = 'unsorted',
  UPLOAD = 'upload',
  USERS = 'users',
  VERIFY = 'verify',
  VK = 'vk',
  VOLTAGE = 'voltage',
  WARNING_SOLID = 'warning-solid',
  WARNING = 'warning',
  WORLD = 'world',
  XING = 'xing',
  YOUTUBE = 'youtube',
  ZOOM_IN = 'zoom-in',
  ZOOM_OUT = 'zoom-out'
}
